import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { user as UserApi } from "@teem/constants/api";

import { objectToFormData } from '@teem/helpers/functions';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public getUser() {
    return this.httpClient.get(`${UserApi.me}`)
  }

  public getTeemUser(uuid: string) {
    return this.httpClient.get(`${UserApi.getTeemUser(uuid)}`)
  }

  public createTeemUser(params: any, options?: any) {
    return this.httpClient.post(`${UserApi.createTeemUser}`, params)
  }

  public updateTeemUser(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.updateTeemUser(params.uuid)}`, fd)
    } else {
      return this.httpClient.put(`${UserApi.updateTeemUser}`, params)
    }
  }

  public action(params: any) {
    return this.httpClient.patch(`${UserApi.action}`, params);
  }

  public getUserBasicInfo() {
    return this.httpClient.get(`${UserApi.basicInfo}`)
  }

  public getNotifications() {
    return this.httpClient.get(`${UserApi.notifications}`)
  }

  public readNotification(id: string) {
    return this.httpClient.get(`${UserApi.readNotification(id)}`)
  }

  public updateAccountInfo(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);

      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.updateAccountInfo}`, fd)
    } else {
      return this.httpClient.put(`${UserApi.updateAccountInfo}`, params)
    }
  }

  public updateBusinessInfo(params: any, options?: any) {

    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);

      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.updateBusinessInfo}`, fd)
    } else {
      return this.httpClient.put(`${UserApi.updateBusinessInfo}`, params)
    }
  }

  public updatePaymentOption(params: any) {
    return this.httpClient.put(`${UserApi.updateBusinessInfo}`, params);
  }

  public updateMerchantInfo(params: any) {
    return this.httpClient.put(`${UserApi.updateMerchantInfo}`, params)
  }

  public verifyHalaBusiness(params: any) {
    return this.httpClient.put(`${UserApi.verifyHalaBusiness}`, params)
  }

  public updatePlan(params: any) {
    return this.httpClient.put(`${UserApi.updatePlan}`, params)
  }

  public updateFinancialGoals(params: any) {
    return this.httpClient.put(`${UserApi.financialGoals}`, params)
  }

  public getFinancialGoals(params?: any) {
    return this.httpClient.get(`${UserApi.financialGoals}${params ? ('?' + this.toQueryString(params)) : ""}`)
  }

  public getFinancialSummary(params?: any) {
    return this.httpClient.get(`${UserApi.financialSummary}${params ? ('?' + this.toQueryString(params)) : ""}`)
  }

  public getFinancialScore(params?: any) {
    return this.httpClient.get(`${UserApi.financialScore}${params ? ('?' + this.toQueryString(params)) : ""}`)
  }

  public saveTerms(params: any) {
    return this.httpClient.put(`${UserApi.terms}`, params)
  }

  public getPermissions() {
    return this.httpClient.get(`${UserApi.permissions}`)
  }

  public getSetting(params: any) {
    return this.httpClient.get(`${UserApi.setting}${params ? ('?' + this.toQueryString(params)) : ""}`)
  }

  public removeHalaNumber() {
    return this.httpClient.delete(`${UserApi.removeHalaNumber}`)
  }

  public addMerchantInfo(type: string, params: any) {
    return this.httpClient.post(`${UserApi.merchants}/${type}`, params);
  }

  public businessInfoUpdateNotify(params: any) {
    return this.httpClient.post(`${UserApi.merchants}/update-notify`, {'uuid':params});
  }

  public addHyperpayInfo(params: any, options?: any) {

    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);

      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.merchants}/hyperpay`, fd)
    } else {
      return this.httpClient.put(`${UserApi.merchants}/hyperpay`, params)
    }
  }

  public addTapInfo(params: any, options?: any) {

    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);

      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.merchants}/tap`, fd)
    } else {
      return this.httpClient.put(`${UserApi.merchants}/tap`, params)
    }
  }

  public updateTapInfo(params: any, options?: any) {
    return this.httpClient.put(`${UserApi.merchants}/update-tap`, params)
    // if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
    //   let fd = objectToFormData(params);

    //   fd.append('_method', 'put');
    //   return this.httpClient.post(`${UserApi.merchants}/tap-bank`, fd)
    // } else {
    //   return this.httpClient.put(`${UserApi.merchants}/tap-bank`, params)
    // }
  }

  public storeMyfatoorah(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.merchants}/myfatoorah`, fd)
    } else {
      return this.httpClient.put(`${UserApi.merchants}/myfatoorah`, params)
    }
  }

  public storeContract(params: any, options?: any) {

    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);

      fd.append('_method', 'put');
      if (params.paymentGateWay == 'tap') {
        return this.httpClient.post(`${UserApi.merchants}/tap-contract`, fd)  
      }else if(params.paymentGateWay == 'myfatoorah'){
        return this.httpClient.post(`${UserApi.merchants}/myfatoorah-contract`, fd)  
      }
      return this.httpClient.post(`${UserApi.merchants}/contract`, fd)
    } else {
      if (params.paymentGateWay == 'tap') {
        return this.httpClient.put(`${UserApi.merchants}/tap-contract`, params)
      }else if(params.paymentGateWay == 'myfatoorah'){
        return this.httpClient.post(`${UserApi.merchants}/myfatoorah-contract`, params)  
      }
      return this.httpClient.put(`${UserApi.merchants}/contract`, params)
    }
  }

  public removeSTCMerchant(type: string) {
    return this.httpClient.delete(`${UserApi.merchants}/${type}`);
  }

  public addTamaraAccessToken(type: string, params: any) {
    return this.httpClient.post(`${UserApi.tamara}/${type}`, params);
  }

  public removeTamaraAccessToken(type: string) {
    return this.httpClient.delete(`${UserApi.tamara}/${type}`);
  }

  public removeMerchant(type: string) {
    return this.httpClient.delete(`${UserApi.merchants}/${type}`);
  }

  public updateCity(params: any) {
    return this.httpClient.put(`${UserApi.addCity}`, params)
  }

  public updateStoreType(params: any) {
    return this.httpClient.put(`${UserApi.addStoreType}`, params)
  }

  protected toQueryString(paramsObject: any): string {
    return Object
      .keys(paramsObject)
      .map(key => {
        if (Array.isArray(paramsObject[key])) {
          return paramsObject[key].map((value, i) => {
            return `${encodeURIComponent(key)}[${i}]=${encodeURIComponent(value)}`
          }).join('&');
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`
      })
      .join('&');
  }

  public uploadFile(formData) {
    // return this.httpClient.post(`${UserApi.uploadLogo}`, formData);
    return this.httpClient.post<any>(`${UserApi.uploadLogo}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public removeFile() {
    return this.httpClient.delete(`${UserApi.removeLogo}`)
  }

  updateStatus(params: any) {
    return this.httpClient.put(`${UserApi.updateStatus}`, params)
  }
  
  public addLog(email: string) {
    return this.httpClient.get(`${UserApi.addLog}?email=${email}`)
  }

  public storeMoyasar(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.merchants}/moyasar`, fd)
    } else {
      return this.httpClient.put(`${UserApi.merchants}/moyasar`, params)
    }
  }

  public sendPaylinkCheckLicense(params: any, options?: any) {
    return this.httpClient.post(`${UserApi.merchants}/paylink/check-license`, params)
  }

  public sendPaylinkOtp(params: any, options?: any) {
    return this.httpClient.post(`${UserApi.merchants}/paylink/otp-validate`, params)
  }

  public sendPaylinkAddBankMerchant(params: any, options?: any) {
    return this.httpClient.post(`${UserApi.merchants}/paylink/add-bank-info`, params)
  }

  public sendPaylinkConfirmingAccount(params: any, options?: any) {
    return this.httpClient.post(`${UserApi.merchants}/paylink/confirming-account`, params)
  }

  public sendPaylinkReConfirmingAccount() {
    return this.httpClient.get(`${UserApi.merchants}/paylink/re-confirming-account`)
  }

  public fetchOtoClientInfo(id: number) {
    return this.httpClient.get(`${UserApi.fetchOtoClientInfo(id)}`);
  }

  public addOtoCredit(amount) {
    return this.httpClient.get(`${UserApi.addOtoCreditAmount(amount)}`);
  }

  public terminateUser() {
    return this.httpClient.delete(`${UserApi.terminateUser}`);
  }

  public storeTapMerchant(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);

      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.merchants}/tap-merchant`, fd)
    } else {
      return this.httpClient.put(`${UserApi.merchants}/tap-merchant`, params)
    }
  }

  public connectLink() {
    return this.httpClient.get(`${UserApi.merchants}/tap-merchant-connect`);
  }

  public updateTapConsent(params: any) {
    return this.httpClient.put(`${UserApi.updateTapConsent}`, params)
  }

  public getFinancialData(payload: any) {
    return this.httpClient.post(`${UserApi.profitLossData}`, payload);
  }

  public storeTeemContract(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${UserApi.merchants}/teem-contract`, fd);
    } else {
      return this.httpClient.put(`${UserApi.merchants}/teem-contract`, params);
    }
  }

}
